var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadBase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 7.99998,
    viewBox: "0 0 24 7.99998",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23 0C22.7348 0 22.4804 0.105356 22.2929 0.292892C22.1054 0.480428 22 0.734782 22 0.999998V4.99999C22 5.26521 21.8946 5.51956 21.7071 5.7071C21.5196 5.89463 21.2652 5.99999 21 5.99999H3C2.73478 5.99999 2.48043 5.89463 2.29289 5.7071C2.10536 5.51956 2 5.26521 2 4.99999V0.999998C2 0.734782 1.89464 0.480428 1.70711 0.292892C1.51957 0.105356 1.26522 0 1 0V0C0.734784 0 0.48043 0.105356 0.292893 0.292892C0.105357 0.480428 0 0.734782 0 0.999998L0 4.99999C0 5.79564 0.31607 6.5587 0.87868 7.12131C1.44129 7.68392 2.20435 7.99998 3 7.99998H21C21.7956 7.99998 22.5587 7.68392 23.1213 7.12131C23.6839 6.5587 24 5.79564 24 4.99999V0.999998C24 0.734782 23.8946 0.480428 23.7071 0.292892C23.5196 0.105356 23.2652 0 23 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadBase);
export default __webpack_public_path__ + "static/media/icon_download_base.fdf1caad081385027c1c41410df09054.svg";
export { ForwardRef as ReactComponent };